import { useState, useEffect } from 'react';

export const useApi = (apiFunction, param = null) => {
    const [output, setOutput] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);   

    useEffect (() => {
        const callApi = async () => {
            try{
                const data = await apiFunction(param);
                setOutput(data);
                
            } catch(error){
                setError(error.response?.data?.message || 'Failed to load.');
            }
            finally{
                setLoading(false);
            }
        };

        callApi();
    }, [])

    return {output, loading, error};
}

